<template>
  <div class="h-1 bg-[#207893]"></div>
  <footer class="py-4 bg-[#191b26]">
    <div class="container mx-auto px-4 text-xs md:text-sm ">
      <p class="text-center text-white py-2">info@congresointernacionaldemaiz.com.ar</p>
      <p class="text-center text-white">COPYRIGHT © 2026. CONGRESO INTERNACIONAL DE MAÍZ</p>
      <p class="text-center text-white text-xs">Desarrollado por <a href="https://www.qreventos.com" target="_blank" class="hover:underline">QREventos.com</a></p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
    methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>